if (!window._)
    window._ = require('lodash');


if (!window.bootstrap)
    window.bootstrap = require('bootstrap');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

if (!window.axios) {
    window.axios = require('axios');
    window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
}
if (window.creditCardType)
    window.creditCardType = require('credit-card-type');
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });


window.countryTranslations = {
};

window.interfaceTranslations = {
    selectedCountryAriaLabel: "País selecionado",
    noCountrySelected: "Nenhum país selecionado",
    countryListAriaLabel: "Lista de países",
    searchPlaceholder: "Procurar",
    zeroSearchResults: "Nenhum resultado encontrado",
    oneSearchResult: "1 resultado encontrado",
    multipleSearchResults: "${count} resultados encontrados",
};

//<script src="node_modules/lite-youtube-embed/src/lite-yt-embed.js"></script>
if (!window.LiteYTEmbed)
    window.LiteYTEmbed = require('lite-youtube-embed');
